import Hero from '../components/Hero';
import '../styles/Careers.css';

function Careers() {
  return (
    <>
    <Hero title="Careers" image="/images/dataanalytics1.png" compact />
    <div className="careers-page">
      <h1 className="careers-main-title">Find What’s Best For You</h1>

      <p className="careers-lead"><strong>Multiple Positions:</strong></p>

      <p className="job-heading">
        <strong>Systems Administrators – Apply now– 01/10/2025 – 3/25/2025</strong>
      </p>
      <p className="job-description">
        To support existing security applications, infrastructure components, Oracle Software,
        Salesforce, and Mark view.
      </p>

      <p className="job-heading">
        <strong>Validation Engineers  – Apply now – 01/10/2025 – 3/25/2025</strong>
      </p>
      <p className="job-description">
        Analyze validation test data to determine whether systems or processes meet validation
        criteria and identify root causes of problems for pharmaceutical and related facilities.
      </p>

      <p className="job-description">
        Jobs based in Charlotte, NC. No travel (US or Intl), but 40% chance of relocation to
        unanticipated locations throughout the U.S. Positions require varying levels of
        education/work experience.
      </p>

      <p className="job-description">
        Email resume to: <a href="mailto:hr@digicloudllc.com">hr@digicloudllc.com</a> or mail to
        Digi Cloud LLC, 125 Floyd Smith Office Park Drive, Suite# 45, Charlotte, NC- 28262.
      </p>
    </div>
    </>
  );
}

export default Careers;
